import React from "react";
import { VerifyPin } from "../../Model/Users";

class Enterpincode extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // PinField: { pin1: "", pin2: "", pin3: "", pin4: "" },
      value: "",
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      IvalidpinMsg: ""
    }
    this.handleChange = this.handleChange.bind(this);
    this.submitVerifypinForm =
      this.submitVerifypinForm.bind(this);
  }

  /*------------------Handle Change------------------*/

  handleChange(value1, event) {

    // const fields = this.state.PinField;

    this.setState({
      IvalidpinMsg: "",
    });
    this.setState({ [value1]: event.target.value });
    // if (e.target.name == "pin1") {

    //   fields['pin1'] = e.target.value;
    //   this.setState({ fields })
    // } else if (e.target.name == "pin2") {

    //   fields['pin2'] = e.target.value;
    //   this.setState({ fields })
    // } else if (e.target.name == "pin3") {

    //   fields['pin3'] = e.target.value;
    //   this.setState({ fields })
    // } else if (e.target.name == "pin4") {

    //   fields['pin4'] = e.target.value;
    //   this.setState({ fields })
    // } else {

    // }

  }

  /*-----------Verify Pin Submit Form--------------*/

  submitVerifypinForm(e) {

    e.preventDefault();
    var postdata = {
      fld_email: this.props.data.state.fields.fld_email,
      fld_mobile: this.props.data.state.fields.fld_mobile,
      countryCode: this.props.data.state.fields.country_code,
      otp: this.state.pin1 + this.state.pin2 + this.state.pin3 + this.state.pin4,
      textmessage: ""
    };

    VerifyPin(postdata).then((res) => {

      var VerifyPinResp = JSON.parse(res.data);

      if (VerifyPinResp.success == true) {
        this.props.data.showresetpasswordview();
        this.setState({
          IvalidpinMsg: VerifyPinResp.message
        })
      } else {
        this.setState({
          IvalidpinMsg: VerifyPinResp.message
        })
      }
    })

  }

  /*----------------------Render----------------------*/

  inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {

      const next = elmnt.target.tabIndex;
      if (next < 4) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };

  render() {
    /*------Verify Pin Button Enable disable-------*/

    // var Pinstate = this.state.PinField;

    // if (Pinstate.pin1 && Pinstate.pin2 && Pinstate.pin3 && Pinstate.pin4) {
    //   var Button = false;
    // } else {
    //   var Button = true;
    // }
    if (
      this.state.pin1 &&
      this.state.pin2 &&
      this.state.pin3 &&
      this.state.pin4
    ) {
      var Button = false;
    } else {
      var Button = true;
    }

    return (
      <>
        <>

          <div className="temp4">
            <hr className="border-red" />
            <hr />
            <div className="temp4-InnerRound50">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
            <div className="temp4-InnerRound51">
              <div className="temp4-InnerRound1">
                <div className="temp4-InnerRound2" />
              </div>
            </div>
            <div className="temp4-InnerRound52">
              <div className="temp4-InnerRound3" />
            </div>
          </div>
          <header>
            <div className="mainNav">
              <div onClick={() => {
                this.props.data.CustomeBackButton();
              }} className="docubayBack white pl-8">
                <img src="img/svg/back.svg" alt="DocuBay" /> Reset password
              </div>
              <div className="topQuestion">
                {/*<img src="img/svg/help.svg" alt="help" />*/}
              </div>
            </div>
          </header>
          <main>
            <section className="mb-0">
              <div className="homeBanner">
                <div className="innerBanner mb-0">
                  <div className="title-reset">
                    <h1>
                      Verification <span className="red"> code</span>
                    </h1>
                    <div className="reset">
                      {this.props.data.state.AlreadyExistMsg.passwordsent}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <form
              method="post"
              name="verifypin"
              onSubmit={this.submitVerifypinForm}
              noValidate="novalidate">
              <section style={{ paddingBottom: 45 }}>
                <div className="temp31">
                  <div className="temp31Inner">
                    <div className="pinInput">
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin1"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          onKeyDown={this.keyDown}
                          value={this.state.pin1 || ""}
                          onChange={(e) => this.handleChange("pin1", e)}
                          tabIndex="1"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin2"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          onKeyDown={this.keyDown}
                          value={this.state.pin2 || ""}
                          onChange={(e) => this.handleChange("pin2", e)}
                          tabIndex="2"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin3"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          onKeyDown={this.keyDown}
                          value={this.state.pin3 || ""}
                          onChange={(e) => this.handleChange("pin3", e)}
                          tabIndex="3"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin4"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          onKeyDown={this.keyDown}
                          value={this.state.pin4 || ""}
                          onChange={(e) => this.handleChange("pin4", e)}
                          tabIndex="4"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                    </div>
                    {this.state.IvalidpinMsg ? (
                      <div className="error error-verifyotp">
                        <img
                          src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                          alt="DocuBay"
                        />
                        <p>{this.state.IvalidpinMsg} </p>
                      </div>
                    ) : null}
                    <div className="formField mt-24 mb-24">

                      <button type="submit" id="sendEnquiryBtn" className="btn-red" disabled={Button}
                        className={
                          Button ? "btn-black" : "btn-red"
                        }>
                        Verify
                      </button>
                    </div>

                  </div>
                </div>
              </section>
            </form>
          </main>
        </>

      </>
    );
  }
}
export default Enterpincode;
